// @flow
import { createSelector } from 'reselect';
import path from 'ramda/es/path';


export type Org = {
  id: number,
  title: string,
  isCamp: boolean,
}

export default createSelector(
  [
    (state, id) => path(['students', 'data', id], state) || {},
  ],
  (student) => {
    const { schoolId, school } = student;
    return {
      id: schoolId,
      title: school,
      isCamp: false,
    };
  }
);
